import React, { useState } from 'react';

import { Stack, TFText } from '@tf/ui';

export const useLogger = () => {
	const [logMessages, setLogMessages] = useState<React.ReactNode[]>([]);

	const clearLog = () => setLogMessages([]);

	const addLogMessage = (message: React.ReactNode) => {
		setLogMessages((m) => [...m, message]);
	};

	return { logMessages, clearLog, addLogMessage };
};

export const Log: React.FC<{ logMessages: React.ReactNode[] }> = ({ logMessages }) => {
	return (
		<Stack gap="4px">
			{logMessages.map((message, index) => (
				<TFText key={index} c="dimmed">
					{message}
				</TFText>
			))}
		</Stack>
	);
};
